import { render } from "./allservices.vue?vue&type=template&id=0355fcfc"
import script from "./allservices.vue?vue&type=script&lang=js"
export * from "./allservices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__